import React from 'react';
import { useIntl } from 'react-intl';

import { Button, HStack } from '@ui-library';
import { ExternalLink } from '@ui-library/icons';
import { Settings } from '@/models';
import { useKioskMode } from '@/hooks/useKioskMode';

import styles from '../index.module.scss';

type AddressInfoProps = {
  address: Settings['property']['address'];
  primaryColor: string;
  onOpenMaps: () => void;
};

export const AddressInfo = ({
  address,
  primaryColor,
  onOpenMaps,
}: AddressInfoProps) => {
  const intl = useIntl();
  const { isEnabled: isKioskMode } = useKioskMode();

  return (
    <HStack>
      <div className={styles.address}>
        <p>{address.address1}</p>
        {address.address2 && <p>{address.address2}</p>}
        <p>
          {address.city}, {address.state}, {address.country} {address.zip}
        </p>
      </div>
      {!isKioskMode && (
        <Button
          size="sm"
          borderColor={primaryColor}
          color="mint.900"
          variant="outline"
          onClick={onOpenMaps}
        >
          {intl.formatMessage({
            id: 'common/openInMaps_label',
            defaultMessage: 'Open in maps',
          })}
          <ExternalLink />
        </Button>
      )}
    </HStack>
  );
};
